import { render } from "./SuscripcionBanner.vue?vue&type=template&id=39f9bbe3&scoped=true"
import script from "./SuscripcionBanner.vue?vue&type=script&lang=js"
export * from "./SuscripcionBanner.vue?vue&type=script&lang=js"

import "./SuscripcionBanner.vue?vue&type=style&index=0&id=39f9bbe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f9bbe3"]])

export default __exports__